module.exports = __webpack_public_path__ + "static/media/sunrise.22d756f5.svg";